import { Icon } from '@amelio/ui-library';

import type { IconProps } from '@amelio/ui-library';
import type { ReactNode } from 'react';

import { SECTION_TITLE_TIGHT } from '@/components/objectives/objectiveStyles';

interface SectionHeadingProps {
    icon: IconProps['name'];
    title: ReactNode;
}

/** The prototype's block header: a bare 24px navy stroke icon next to a 24px/500 title. */
export default function SectionHeading({ icon, title }: SectionHeadingProps) {
    return (
        <div className={'flex items-center gap-3'}>
            <Icon
                name={icon}
                size={24}
                colorClassName={'text-navy'}
                strokeWidth={1.5}
            />

            <h3 className={SECTION_TITLE_TIGHT}>{title}</h3>
        </div>
    );
}
